/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemVideoTrackFromJSON(json) {
    return WallItemVideoTrackFromJSONTyped(json, false);
}
export function WallItemVideoTrackFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'active': !exists(json, 'active') ? undefined : json['active'],
        'orientation': !exists(json, 'orientation') ? undefined : json['orientation'],
        'cameraSubject': !exists(json, 'camera_subject') ? undefined : json['camera_subject'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'backgrounded': !exists(json, 'backgrounded') ? undefined : json['backgrounded'],
    };
}
export function WallItemVideoTrackToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'active': value.active,
        'orientation': value.orientation,
        'camera_subject': value.cameraSubject,
        'name': value.name,
        'backgrounded': value.backgrounded,
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemVideoTrackOrientation;
(function (WallItemVideoTrackOrientation) {
    WallItemVideoTrackOrientation["DOWN"] = "DOWN";
    WallItemVideoTrackOrientation["LEFT"] = "LEFT";
    WallItemVideoTrackOrientation["RIGHT"] = "RIGHT";
    WallItemVideoTrackOrientation["UP"] = "UP";
})(WallItemVideoTrackOrientation || (WallItemVideoTrackOrientation = {}));
/**
* @export
* @enum {string}
*/
export var WallItemVideoTrackCameraSubject;
(function (WallItemVideoTrackCameraSubject) {
    WallItemVideoTrackCameraSubject["PERSON"] = "CAMERA_SUBJECT_PERSON";
    WallItemVideoTrackCameraSubject["SCREEN"] = "CAMERA_SUBJECT_SCREEN";
    WallItemVideoTrackCameraSubject["WORLD"] = "CAMERA_SUBJECT_WORLD";
})(WallItemVideoTrackCameraSubject || (WallItemVideoTrackCameraSubject = {}));
//# sourceMappingURL=WallItemVideoTrack.js.map